import React from 'react'

import { getCloudinaryUrl } from 'core/classes/helpers'
import settings from 'src/config/settings'

import styles from './APLLoginLayout.module.scss'

export interface IProps {
  content?: React.ReactNode
}

export const APLLoginLayout: React.FunctionComponent<IProps> = ({ content }) => {
  const backgroundIMG = `${settings.dataServerUrl}/builder/rs/forms/1161/images/spr/APLLoginBackground.jpg`

  return (
    <div
      className={styles.root}
      style={{
        background: `url('${getCloudinaryUrl({
          src: backgroundIMG,
        })}') center / cover no-repeat #374590`,
      }}
    >
      <div className={styles.centering}>
        <div className={styles.content}>{content}</div>
      </div>
    </div>
  )
}
